import React from 'react'

import Base from '../_Base'

const ChevronUp = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <polygon
      transform="translate(12.000000, 11.700000) rotate(-90.000000) translate(-12.000000, -11.700000) "
      points="8.3 7.1 9.7 5.7 15.7 11.7 9.7 17.7 8.3 16.3 12.9 11.7"
    />
  </Base>
)

export default ChevronUp
